<template>
  <div class="template-documentos-barra-acoes">
    <Panel lineColor="var(--primary-color)">
      <div class="barra-conteudo">
        <div class="barra-status">
          <template v-if="carregando">
            <v-progress-circular indeterminate size="16" width="2" />
            <span>Carregando layout…</span>
          </template>
          <template v-else-if="dirty">
            <v-icon size="14" color="warning">fas fa-info-circle</v-icon>
            <span class="texto-alerta">Alterações não salvas no HTML.</span>
          </template>
          <template v-else>
            <v-icon size="14" color="success">fas fa-check-circle</v-icon>
            <span>Layout sincronizado com o servidor.</span>
          </template>
        </div>
        <div class="barra-botoes">
          <FormButton
            outlined
            type="primario"
            color="primario"
            text="Copiar HTML"
            beforeIcon="fas fa-copy"
            :disabled="desabilitado"
            @click="$emit('copiar')"
          />
          <FormButton
            outlined
            type="primario"
            color="primario"
            text="Pré-visualizar PDF"
            beforeIcon="fas fa-file-pdf"
            :disabled="desabilitado"
            :loading="previewLoading"
            @click="$emit('preview')"
          />
          <FormButton
            type="perigo"
            text="Restaurar padrão"
            beforeIcon="fas fa-undo"
            :disabled="desabilitado || restaurarLoading"
            @click="$emit('restaurar')"
          />
          <FormButton
            type="submissao"
            text="Salvar layout"
            beforeIcon="fas fa-save"
            :disabled="desabilitado || !dirty"
            :loading="salvarLoading"
            @click="$emit('salvar')"
          />
        </div>
      </div>
    </Panel>
  </div>
</template>

<script>
import Panel from "@/components/Panel";
import FormButton from "@/components/form/FormButton";

export default {
  name: "TemplateDocumentosActionBar",
  components: { Panel, FormButton },
  props: {
    dirty: { type: Boolean, default: false },
    carregando: { type: Boolean, default: false },
    desabilitado: { type: Boolean, default: false },
    salvarLoading: { type: Boolean, default: false },
    previewLoading: { type: Boolean, default: false },
    restaurarLoading: { type: Boolean, default: false }
  }
};
</script>

<style scoped>
.template-documentos-barra-acoes {
  margin-top: 40px;
}

.barra-conteudo {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  flex-wrap: wrap;
  text-align: left;
}

.barra-status {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 0.9rem;
  color: #4b5563;
}

.barra-botoes {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
}

.texto-alerta {
  color: var(--alert-color, #d97706);
  font-weight: 600;
}
</style>
